SET_MESSAGE_BOX_VIEWED